import React from "react";

import keyExists from "../../../utils/keyExists";
import readableTime from '../../../utils/readableTime';

import "./DeviceItemUptime.scss";

export default function DeviceItemUptime(props) {
    if (props.device === undefined || props.device.upTime === null) {
        return (
            <span className="device-item-uptime device-item-uptime--na">
                <h3>N/A</h3>
            </span>
        );
    }

    const upTime = keyExists("upTime.result", props.device) ? `${Math.round(props.device.upTime.result)}%` : "N/A";
    // const onlineTime = props.device.upTime !== null ? `${Math.round(props.device.upTime.onlineTime)}%` : "N/A";
    const since = props.device.upTime !== null ? readableTime(props.device.upTime.start) : "";

    return (
        <span className="device-item-uptime">
            <h4>
                Uptime
                <br />
                <strong> {upTime}</strong>
            </h4>
            {/* <h4>Online<br /><strong> {onlineTime}</strong></h4> */}
            <p>
                since
                <br />
                <strong>{since}</strong>
            </p>
        </span>
    );
}

